export const appProduction = process.env.APP_PRODUCTION === 'true';
export const appSystemKey = process.env.APP_SYSTEM_KEY || '';
export const appGenericKey = null;
export const appBrowser = process.env.APP_BROWSER === 'true';
export const appDebug = process.env.APP_DEBUG === 'true';
export const appApiURL = process.env.APP_API_URL || '';
export const appGoogleMapsApiKey = 'AIzaSyDd6YEwUDDugFwDMYTQiV24ELxpZLHQl3k';
export const appOnePush = process.env.APP_ONESIGNAL_UID || 'd8829bd5-00d9-4eba-bb91-6e2bbd4895b2';

// Get both bundle IDs from environment
const defaultBundleId = process.env.APP_BUNDLE_ID || '';
const androidAppId = process.env.APP_AND_APP_ID || '';

// Use APP_AND_APP_ID if it exists and is different from APP_BUNDLE_ID
export const appBundleID = (androidAppId && androidAppId !== defaultBundleId) 
    ? androidAppId 
    : defaultBundleId;

export const appName = process.env.APP_NAME || '';